import { PERMISSION } from '@/constants/permission.constant';

const yearList = () => import('@/views/configuration/years/List.vue');
const addyear = () => import('@/views/configuration/years/Add.vue');
const edityear = () => import('@/views/configuration/years/Edit.vue');

export const yearRoute = [
  {
    path: '/configuration/years',
    name: 'year-list',
    component: yearList,
    meta: { requiresAuth: false, permissions: [PERMISSION.YEAR_READ] },
  },

  {
    path: '/configuration/years/create',
    name: 'year-create',
    component: addyear,
    meta: { requiresAuth: false, permissions: [PERMISSION.YEAR_CREATE] },
  },
  {
    path: '/configuration/years/update',
    name: 'year-edit',
    component: edityear,
    meta: { requiresAuth: false, permissions: [PERMISSION.YEAR_UPDATE] },
  },
];
